import { Box, Container, Heading, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function MaualPLD() {
    return (
        <Stack alignItems="center" mx={10}>
            <Container maxWidth="7xl" pt={24}>
                <Header />
                <Head>
                    <title>
                        MANUAL DE CUMPLIMIENTO EN MATERIA DE PREVENCIÓN DE LAVADO DE DINERO, COMBATE
                        AL FINANCIAMIENTO AL TERRORISMO DE GRUPO GUÍA
                    </title>
                </Head>
                <Box mb="4" mt="24">
                    <Heading
                        as="h1"
                        fontSize={{ md: "4xl", base: "2xl" }}
                        textAlign="center"
                        mb="8"
                        color="accent.500"
                        fontWeight="bold"
                    >
                        MANUAL DE CUMPLIMIENTO EN MATERIA DE PREVENCIÓN DE LAVADO DE DINERO, COMBATE
                        AL FINANCIAMIENTO AL TERRORISMO DE GRUPO GUÍA
                    </Heading>
                </Box>
                <Box lineHeight="1.8" mb="8">
                    <Heading
                        as="h2"
                        mb="6"
                        mt="4"
                        color="accent.500"
                        fontWeight="400"
                        fontSize={{ md: "3xl", base: "xl" }}
                        textAlign="left"
                    >
                        Objetivo
                    </Heading>
                    <Text>
                        Establecer las políticas, medidas y procedimientos para dar cumplimiento a
                        las obligaciones contenidas en la Ley Federal para la Prevención e
                        Identificación de Operaciones con Recursos de Procedencia Ilícita, en cuanto
                        se esté en el supuesto de dar cumplimiento a informar, custodiar, proteger,
                        resguardar y evitar la destrucción u ocultamiento de la información y
                        documentación de soporte que se desprenda de la realización de actividades
                        vulnerables, así como de la identificación de sus clientes o usuarios que
                        intervengan.
                    </Text>
                </Box>
                <Box lineHeight="1.8" mb="12">
                    <Heading
                        as="h2"
                        mb="6"
                        mt="4"
                        color="accent.500"
                        fontWeight="400"
                        fontSize={{ md: "3xl", base: "xl" }}
                        textAlign="left"
                    >
                        Alcance
                    </Heading>
                    <Text mb={8}>
                        El presente manual será de conocimiento y uso obligatorio para los
                        integrantes de la organización, apoderados, empleados, funcionarios,
                        directores, clientes actuales y futuros, partes relacionadas y en general
                        cualquier persona física o moral que actúe en nombre de Grupo Guía, así como
                        de quienes intervengan en actos que la ley considere como vulnerables.
                    </Text>
                    <Heading
                        as="h2"
                        mb="4"
                        mt="4"
                        color="accent.500"
                        fontWeight="400"
                        fontSize={{ md: "3xl", base: "xl" }}
                        textAlign="left"
                    >
                        Marco Normativo
                    </Heading>
                    <Text mb={8}>
                        1.- Ley Federal para la Prevención e Identificación de operaciones de
                        recursos de procedencia ilícita (LFPIORPI).
                        <br />
                        <br />
                        2.- Reglamento de la Ley Federal para la Prevención e Identificación de
                        Operaciones con Recursos de Procedencia Ilícita.
                        <br />
                        <br />
                        3.- Reglas de Carácter General a que se refiere la Ley Federal para la
                        Prevención e Identificación de Operaciones con Recursos de Procedencia
                        Ilícita.
                        <br />
                        <br />
                        4.- Código Penal Federal.
                        <br />
                        <br />
                    </Text>
                    <Heading
                        as="h2"
                        mb="4"
                        mt="4"
                        color="accent.500"
                        fontWeight="400"
                        fontSize={{ md: "3xl", base: "xl" }}
                        textAlign="left"
                    >
                        Glosario
                    </Heading>
                    <Box mb={8}>
                        <Text>
                            Acto u operación: la realización de una compraventa de un bien inmueble.
                            Usuario: las partes compradoras en una operación.
                            <br />
                            <br />
                            <strong>Cliente:</strong> Dueño de una propiedad o desarrollo que
                            encomienda a GUIA para su comercialización.
                            <br />
                            <br />
                            <strong>Persona física:</strong> individuo que realiza cualquier
                            actividad económica (vendedor, comerciante, empleado, profesionista,
                            etc.), el cual tiene derechos y obligaciones.
                            <br />
                            <br />
                            <strong>Persona moral:</strong> conjunto de personas físicas, que se
                            unen para la realización de un fin colectivo, son entes creados por el
                            derecho, no tienen una realidad material o corporal (no se pueden tocar
                            como tal como en el caso de una persona física), sin embargo, la ley les
                            otorga capacidad jurídica para tener derechos y obligaciones.
                            <br />
                            <br />
                            <strong>Fideicomiso:</strong> contrato a través del cual una persona
                            transmite la propiedad de uno o más bienes (muebles o inmuebles) o
                            derechos para ser destinados a fines lícitos y determinados.
                            <br />
                            <br />
                            <strong>Acta constitutiva:</strong> es el documento necesario y
                            obligatorio para la formación legal de una organización o sociedad.
                            <br />
                            <br />
                            <strong>Poder:</strong> documento en donde se plasman facultades de
                            representación de personas o empresas y se autorizan ante los notarios o
                            corredores públicos, quienes garantizan la identidad de las personas
                            otorgantes.
                            <br />
                            <br />
                            <strong>Constancia de situación fiscal (CIF):</strong> acta que permite
                            conocer el estatus de los contribuyentes ante el SAT.
                            <br />
                            <br />
                            <strong>Actividades vulnerables:</strong> a las actividades que se
                            refiere el artículo 17 de LFPIORPI: Artículo 17. Para efectos de esta
                            Ley se entenderán Actividades Vulnerables y, por tanto, objeto de
                            identificación en términos del artículo siguiente, las que a
                            continuación se enlistan: ... V.
                            <br />
                            <br />
                            La prestación habitual o profesional de servicios de construcción o
                            desarrollo de bienes inmuebles o de intermediación en la transmisión de
                            la propiedad o constitución de derechos sobre dichos bienes, en los que
                            se involucren operaciones de compra o venta de los propios bienes por
                            cuenta o a favor de clientes de quienes presten dichos servicios. Serán
                            objeto de Aviso ante la Secretaría cuando el acto u operación sea por
                            una cantidad igual o superior al equivalente a ocho mil veinticinco
                            veces el salario mínimo vigente en el Distrito Federal;
                            <br />
                            <br />
                            <strong>Oficial de cumplimiento:</strong> persona autorizada por Guía
                            como responsable de dar cumplimiento a las disposiciones como sujeto de
                            LFPIORPI.
                            <br />
                            <br />
                            <strong>Beneficiario controlador:</strong> a la persona o grupo de
                            personas que:
                            <br />
                            <br />
                        </Text>
                        <Text mb={8} ml={10}>
                            a) Por medio de otra o de cualquier acto, obtiene el beneficio derivado
                            de éstos y es quien, en última instancia, ejerce los derechos de uso,
                            goce, disfrute, aprovechamiento o disposición de un bien o servicio, o
                        </Text>
                        <Text mb={8} ml={10}>
                            b) Ejerce el control de aquella persona moral que, en su carácter de
                            cliente o usuario, lleve a cabo actos u operaciones con quien realice
                            actividades vulnerables, así como las personas por cuenta de quienes
                            celebra alguno de ellos. Se entiende que una persona o grupo de personas
                            controla a una persona moral cuando, a través de la titularidad de
                            valores, por contrato o de cualquier otro acto, puede:
                        </Text>
                        <Text mb={8} ml={20}>
                            1. Imponer, directa o indirectamente, decisiones en las asambleas
                            generales de accionistas, socios u órganos equivalentes, o nombrar o
                            destituir a la mayoría de los consejeros, administradores o sus
                            equivalentes;
                            <br />
                            <br />
                            2. Mantener la titularidad de los derechos que permitan, directa o
                            indirectamente, ejercer el voto respecto de más del cincuenta por ciento
                            del capital social, o
                            <br />
                            <br />
                            3. Dirigir, directa o indirectamente, la administración, la estrategia o
                            las principales políticas de la misma.
                            <br />
                            <br />
                        </Text>
                        <strong>Beneficiario:</strong> persona designada por el titular de un
                        convenio o contrato celebrado con alguna persona que realice una actividad
                        vulnerable para que, en caso de fallecimiento de dicho titular, tal persona
                        designada ejerza ante ésta los derechos derivados del convenio o contrato
                        respectivo.
                        <br />
                        <br />
                        <strong>GUIA:</strong> Guía Excelencia Inmobiliaria S.A. De C.V. empresa
                        cuya actividad económica preponderante es la intermediación de inmuebles que
                        opera bajo la marca denominada como “GUIA”.
                        <br />
                        <br />
                        <strong>Avisos:</strong> aquella información presentada a el SAT en términos
                        del artículo 17 de LFPIORPI.
                        <br />
                        <br />
                        <strong>Manual:</strong> documento clave para garantizar que GUIA de un
                        adecuado cumplimiento a los procedimientos en materia de prevención de
                        operaciones con recursos de procedencia ilícita y financiamiento al
                        terrorismo.
                        <br />
                        <br />
                        <strong>Relación de negocios:</strong> aquella establecida de manera formal
                        y cotidiana entre quien realiza una actividad vulnerable y sus clientes,
                        excluyendo los actos u operaciones que se celebren ocasionalmente, sin
                        perjuicio de lo que establezcan otras disposiciones legales y
                        reglamentarias.
                        <br />
                        <br />
                        <strong>Representante legal:</strong> es todo aquel que actúa en nombre de
                        otra persona (física o moral) y que es reconocido por la ley por así tenerlo
                        documentado.
                        <br />
                        <br />
                        <strong>SAT:</strong> Servicio de Administración Tributaria, órgano
                        desconcentrado de la Secretaría. Secretaria: Secretaría de Hacienda y
                        Crédito Público.
                        <br />
                        <br />
                        <strong>UIF:</strong> Unidad de Inteligencia Financiera, adscrita a la
                        Secretaría.
                        <br />
                        <br />
                        <strong>Cotejo de documentación:</strong> revisión de la documentación
                        comparando un documento original con una copia simple.
                        <br />
                        <br />
                        <strong>Archivo:</strong> documentos, datos o información conservada en
                        formato impreso o digital, a través de medios electrónicos u ópticos, que se
                        mantiene integra e inalterada al momento que se generó por primera vez,
                        siendo accesible para su consulta.
                        <br />
                        <br />
                        <strong>PREVENET:</strong> es un sistema de almacenamiento digital conocido
                        como “nube”, que permite la consulta a través de accesos asignados,
                        atendiendo los requerimientos cumplimiento de la LFPIORPI.
                        <br />
                        <br />
                        <strong>GUIARVIS:</strong> Plataforma de comunicación interna y desarrollo
                        humano para beneficio de todos los colaboradores de Grupo Guía.
                        <br />
                        <br />
                        <strong>Proceso de integración:</strong> proceso que llenan los gerentes
                        para indicar al área administrativa las operaciones realizadas, cuánto
                        cobrar de comisión y cómo dispersar la comisión.
                        <br />
                        <br />
                        <strong>PCLOUD:</strong> es su espacio personal en la nube donde puede
                        almacenar todos sus archivos y carpetas
                        <br />
                        <br />
                        <strong>Asesor:</strong> responsable de orientar de principio a fin a un
                        cliente con afanes comerciales, ya sea para opcionar o comprar un bien
                        inmueble dentro de Grupo Guía.
                        <br />
                        <br />
                        <strong>Coordinador:</strong> responsable de reunir la documentación
                        necesaria para hacer el debido registro del acto u operación en el portal de
                        PREVENET, y almacenar la documentación en pCloud, vigilando que los procesos
                        se hagan de acuerdo a los lineamientos establecidos y se lleven a cabo en
                        tiempo y forma.
                        <br />
                        <br />
                        <strong>Comisionista:</strong> persona que se dedica a desempeñar comisiones
                        mercantiles, vendiendo a cuenta de otro y cobrando una comisión.
                        <br />
                        <br />
                        <strong>
                            Proceso para identificar operaciones, usuarios y clientes
                        </strong>{" "}
                        conforme al acuerdo 02/2013, se emiten las reglas de carácter general a que
                        se refiere la ley federal para la prevención e identificación de operaciones
                        con recursos de procedencia ilícita
                        <br />
                        <br />
                        <Text mb={8} ml={20}>
                            a) <strong>Identificaremos a clientes y partes</strong> que intervienen
                            en una operación, solicitando muestren su identificación oficial vigente
                            quedando obligado GUIA a documentar mediante copia física o electrónica
                            para integrar el expediente. Así mismo tratándose de personas físicas
                            con nacionalidad mexicana se recabará la siguiente información:
                        </Text>
                        <strong>Persona Física</strong> <br />
                        Datos y documentos de identificación de los clientes o usuarios que realicen
                        actividades vulnerables, respecto de aquellos que sean personas físicas y
                        que declaren ser de nacionalidad mexicana o de nacionalidad extranjera con
                        las condiciones de residente temporal o residente permanente, en términos de
                        la ley de migración
                        <br />
                        <Text mb={8} ml={40}>
                            1. Nombre completo
                            <br />
                            2. Fecha y lugar de nacimiento
                            <br />
                            3. Ocupación <br />
                            4. Domicilio particular de residencia <br />
                            5. Teléfono y correo electrónico <br />
                            6. Clave Única de Registro de Población y Registro Federal de
                            Contribuyentes <br />
                            7. Manifestación respecto a la existencia del beneficiario controlador{" "}
                            <br />
                            8. Manifestación del origen de sus recursos
                            <br />
                        </Text>
                        GUIA conservara el expediente digital y/o físico (escaneados de manera
                        legibles) que soporte la operación, quedando integrado este por los
                        siguientes documentos:
                        <br /> <br />
                        <Text mb={8} ml={20}>
                            1. Contrato mercantil (cuando se entiende prestado el servicio de
                            intermediación)
                            <br />
                            2. Identificación oficial (vigente) <br />
                            3. CURP (para el caso de personas físicas de nacionalidad mexicana o de
                            nacionalidad extranjera con las condiciones de residente temporal o
                            residente permanente) <br />
                            4. RFC (para el caso de personas físicas de nacionalidad mexicana o de
                            nacionalidad extranjera con las condiciones de residente temporal o
                            residente permanente)
                            <br />
                            5. Comprobante de domicilio (vigencia y/o actualización cada 3 meses){" "}
                            <br />
                            6. Formato de identificación del cliente <br />
                            7. Poder si fuese el caso (esto cuando el adquiriente no pudiese asistir
                            a la firma y otorga poder a alguien más para que actué en su
                            representación)
                            <br />
                            8. Si cuenta con beneficiario controlador llenar formato de
                            identificación (formato de datos generales beneficiario controlador)
                            <br />
                            9. Constancia de consulta de listas UIF <br />
                            10. Contrato de compraventa y/o escritura <br />
                            11. Constancia anti lavado (solo aplica para el usuario)
                            <br />
                        </Text>
                        <strong>Persona Moral</strong>
                        <br />
                        Datos y documentos de identificación de los clientes o usuarios que realicen
                        actividades vulnerables, respecto de aquellos que sean personas morales de
                        nacionalidad mexicana. Persona moral y/o fideicomiso (desarrollo)
                        <br />
                        <br />
                        Tratándose de personas morales se recabará la siguiente información:
                        <br />
                        <br />
                        <Text mb={8} ml={20}>
                            1. Denominación o razón social
                            <br />
                            2. Actividad u objeto social
                            <br />
                            3. Registro Federal de Contribuyentes (con homoclave)
                            <br />
                            4. El número de serie de la firma electrónica avanzada (cuando cuenten
                            con ella)
                            <br />
                            5. Domicilio fiscal y sucursal
                            <br />
                            6. Teléfono y correo electrónico
                            <br />
                            7. Nombre completo sin abreviaturas del administrador o administradores,
                            director, gerente general o apoderado, que cuente con las facultades
                            suficientes para obligar a la sociedad
                            <br />
                            8. Manifestación del origen de sus recursos
                            <br />
                        </Text>
                        GUIA conservara el expediente digital y/o físico (escaneados de manera
                        legibles) que soporte la operación, quedando integrado este por los
                        siguientes documentos:
                        <br />
                        <br />
                        <Text mb={8} ml={20}>
                            1. Contrato mercantil (cuando se entiende prestado el servicio de
                            intermediación)
                            <br />
                            2. Cedula de Identificación fiscal
                            <br />
                            3. Acta constitutiva
                            <br />
                            4. Comprobante de domicilio (vigencia y/o actualización cada 3 meses)
                            <br />
                            5. Formato de identificación del cliente
                            <br />
                            6. Si cuenta con beneficiario controlador llenar formato de
                            identificación
                            <br />
                            7. Constancia de consulta en listas UIF
                            <br />
                            8. Identificación oficial del representante legal
                            <br />
                            9. Poder del representante legal
                            <br />
                            10. Contrato de compraventa y/o escritura
                            <br />
                            11. Constancia antilavado (solo aplica para el usuario)
                        </Text>
                        Persona Física Extranjera Datos y documentos de identificación de los
                        clientes o usuarios que realicen actividades vulnerables, respecto de
                        aquellos que sean personas físicas extranjeras, con las condiciones de
                        estancia de visitante o distinta a las establecidas en la fracción I del
                        artículo 12 de las reglas de carácter general, en términos de la ley de
                        migración Tratándose de clientes persona física extranjera, se solicitará el
                        documento adicional que acredite su legal estancia en el País, ya sea
                        temporal o permanente, en los términos de la Ley de Migración.
                        <br />
                        <br />
                        Persona Moral Extranjera Datos y documentos de identificación de los
                        clientes o usuarios que realicen actividades vulnerables, respecto de
                        aquellos que sean personas morales de nacionalidad extranjera.
                        <br />
                        <br />
                        Parte(s) que actúan a nombre de otras: En caso de que Guía cuente con
                        información basada en documentos o información recabada y cierta acerca de
                        que algún cliente o parte relacionada actúa en nombre de otra persona, sin
                        que exista la declaración manifiesta de alguna de estas ultima se deberá
                        solicitar al cliente o parte relacionada información adicional que le
                        permita dentro de sus posibilidades identificar al propietario real de los
                        recursos o bienes involucrados en la operación respectiva, sin que esto
                        afecte o trasgreda los derechos de confidencialidad frente a terceros.
                        <br />
                        <br />
                        <strong>Anexos </strong>
                        <br />
                        <br />
                        Se deberán incluir los siguientes anexos en cada operación, tanto para el
                        cliente como para el usuario.
                        <br />
                        <br />
                        Anexo 1: formato de identificación en donde plasma la información general de
                        todos los clientes y usuarios.
                        <Text mb={8} ml={20}>
                            Formato 1.1: identificación de persona física
                            <br />
                            Formato 1.2: identificación de persona moral
                        </Text>
                        Anexo 2: formato identificación de beneficiario controlador Formato 2.1:
                        identificación de persona física
                        <br />
                        <br />
                        Anexo 3: formato constancia de anti lavado
                        <br />
                        <br />
                        Anexo 4: contrato mercantil
                        <br />
                        <br />
                        <strong>Vigilancia</strong>
                        <br />
                        <br />
                        Guía designara a un representante para el cargo de oficial de cumplimento de
                        las obligaciones contempladas en la LFPIORPI, destinándose para tal efecto a
                        ALEJANDRO DIBILDOX VILLALOBOS. Así mismo, se conformará un comité de
                        cumplimiento según lo contemplado en el presente manual, así como de su
                        revisión y actualización, mismo que deberá sesionar cada 6 meses, levantando
                        minuta correspondiente de la atención de asuntos relacionados con el
                        cumplimiento del presente documento, así como temas relacionados con la
                        supervisión de la información presentada a las autoridades, revisión del
                        manual y propuestas de actualización de datos e información complementaria.
                        <br />
                        <br />
                        Así mismo, se conformará un comité de cumplimiento según lo contemplado en
                        el presente manual, así como de su revisión y actualización, mismo que
                        deberá sesionar cada 6 meses, levantando minuta correspondiente de la
                        atención de asuntos relacionados con el cumplimiento del presente documento,
                        así como temas relacionados con la supervisión de la información presentada
                        a las autoridades, revisión del manual y propuestas de actualización de
                        datos e información complementaria. Así mismo, será responsabilidad del
                        comité de cumplimiento, la verificación y revisión de los expedientes de
                        identificación de los clientes y partes relacionadas que formen parte de las
                        actividades vulnerables reportadas.
                        <br />
                        <br />
                        <strong>Proceso de revisión diaria</strong>
                        <br />
                        <br />
                        Se supervisa que las operaciones cargadas en la plataforma GUIARVIS estén
                        debidamente registradas correctamente en PREVENET así como el expediente
                        digital colocado en el almacenamiento autorizado PCLOUD, para su posterior
                        autorización y liberación de comisiones, en caso de que el registro no esté
                        listo se detendrá el proceso hasta que quede registrado según los
                        lineamientos.
                        <br />
                        <br />
                        <strong>
                            Proceso para la identificación de clientes, usuarios como partes de
                            riesgo.
                        </strong>
                        <br />
                        <br />
                        Guía registrará y dará seguimiento a las operaciones realizadas con sus
                        clientes y partes relacionadas de sus operaciones vulnerables, a través de
                        la herramienta tecnológica especializada denominada “PREVENET”, misma que
                        será utilizada para presentar informes mensuales ante el portal de internet
                        para la prevención de lavado de dinero, herramienta que almacena y organiza
                        la información y documentación del expediente.
                        <br />
                        <br />
                        La herramienta digital “PREVENET” cuenta con las certificaciones de
                        seguridad, para el almacenaje y resguardo de la información electrónica,
                        resguardo y gestión de datos para la preparación, presentación y
                        administración de los avisos ante el Sistema de Administración Tributaria
                        (SAT) en cumplimiento a las disposiciones de la Ley Federal para la
                        Prevención e Identificación de Operaciones con Recursos de Procedencia
                        Ilícita, su Reglamento y las Reglas de carácter general que al efecto ha
                        publicado la Secretaría de Hacienda y Crédito Público
                        <br />
                        <br />
                        <strong>Procedimiento para presentar avisos a través de PREVENET:</strong>
                        <br />
                        <br />
                        Operación a escritura: se reporta en el mes posterior de la fecha de
                        escritura.
                        <br />
                        <br />
                        Operación a contrato: se reporta al mes posterior de la fecha del contrato.
                        <br />
                        <br />
                        Guía presentara ante SHCP, a través de “PREVENET” dentro de los primeros 17
                        días de cada mes, el reporte de operaciones relevantes en los que haya
                        participado en el mes inmediato anterior y que correspondan a operaciones
                        vulnerables y que se encuentren dentro de las cantidades contempladas en los
                        umbrales establecidos. En caso de que Guía no haya participado en
                        operaciones relevantes en el mes correspondiente, deberá presentar dentro de
                        los mismos términos el informe correspondiente en “ceros”.
                        <br />
                        <br />
                        El procedimiento que deberá utilizar de manera interna Guía a través del
                        departamento o área responsable, será el siguiente: <br />
                        Una vez que el cliente se puso en contacto con el asesor y este recabo los
                        documentos necesarios para integrar el expediente, el coordinador se encarga
                        de:
                        <Text mb={8} ml={20}>
                            1. Ingresar al portal de PREVENET
                            https://portal.prevenet.com.mx/Account/Default.aspx Con usuario y
                            contraseña 2. Dar de alta al cliente persona física/moral y/o
                            fideicomiso en la sección agregar cliente 3. Integrar el expediente del
                            cliente 4. Ingresar a la sección operaciones 5. Seleccionar al cliente
                            6. Agregar información de la contraparte y datos de la operación 7.
                            Integrar el expediente de la contraparte y operación. Una vez
                            registradas las operaciones, el oficial de cumplimiento ingresa a la
                            plataforma PREVENET y continúa para concluir. 8. Genera un aviso masivo
                            desde PREVENET. 9. Descarga el XML. 10. Ingreso al portal de internet de
                            prevención de lavado de dinero SPPLD
                            https://sppld.sat.gob.mx/pld/interiores/sppld.html 11. Se genera un
                            aviso masivo desde el portal en los tiempos y bajo la forma prevista en
                            la ley federal para la prevención e identificación de operaciones con
                            recursos de procedencia Ilícita. 12. Se recibe un acuse de aceptación de
                            la secretaria de hacienda y crédito público. 13. Se agrega al portal de
                            Prevenet el acuse de aceptación
                        </Text>
                        <strong>Obligación de la reserva y resguardo de la documentación</strong>
                        <br />
                        <br />
                        Guía conservara la información y documentación recabada por las operaciones
                        relacionadas a las actividades vulnerables y que hayan sido objeto de aviso,
                        durante un término de 5 años siguientes a que se realice esta. Obligándose a
                        tener absoluta reserva sobre dicha información y documentación, salvo que
                        esta sea requerida por autoridad competente y deba ser entregada previa
                        notificación con las formalidades que la ley exija.
                        <br />
                        <br />
                        <strong>Proceso de resguardo de la información en pCloud</strong>
                        <br />
                        <br />
                        Coordinación se encarga de revisar el expediente completo que se requiere
                        para el correcto aviso y cumplimiento de la LFPIORPI, una vez que se tiene
                        listo y se registra en la plataforma Prevenet al mismo tiempo se resguarda
                        en la carpeta asignada de pCloud de manera digital con orden y legible.
                        <br />
                        <br />
                        <strong>Capacitación</strong>
                        <br />
                        <br />
                        Guía elaborara un plan de capacitación y difusión del conocimiento,
                        aplicación y uso del presenta manual, dirigido a su personal interno,
                        funcionarios, colaboradores y en general cualquier miembro de su
                        organización que participen en asuntos relativos a las actividades
                        vulnerables. Esta deberá de hacerse mediante una inducción y una
                        actualización por lo menos una vez al año.
                        <br />
                        <br />
                        Fecha de última revisión: 18 julio de 2022 Quien reviso: Ana Elvia Barajas
                        Macías y Karen Anahi Silva Torres
                        <br />
                        <br />
                    </Box>
                </Box>
                <Footer visible={false} />
            </Container>
        </Stack>
    );
}
